import React from 'react';
import { useMasterLabel } from '../../hooks/useMasterLabel';

// Drop-in text component that renders a master-data label in the active language.
// Use this anywhere the UI currently prints `spec.name`, `category.spcategoryName`, etc.
//
//   <MasterLabel type="masterSpecialty" id={spec.specialtyId} field="name" fallback={spec.name} />
//
// Passing `as` swaps the wrapper element (defaults to <span>). Extra props are spread
// onto the wrapper so className / style / data-testid all just work.
const MasterLabel = ({ type, id, field, fallback = '', as: Tag = 'span', ...rest }) => {
    const value = useMasterLabel(type, id, field, fallback);
    const defaultTestId = `master-label-${type}-${id}-${field}`;
    return <Tag data-testid={defaultTestId} {...rest}>{value}</Tag>;
};

export default MasterLabel;
